import React from 'react';
import './index.css';
import { ListGroup, ListGroupItem } from 'reactstrap';

const Detaje = ({ bill }) => {
    const detajeList = []
    detajeList.push(["Emri i Dokumentit", bill.Titulli])
    detajeList.push(["Date Rregjistrimi", bill.DateRegjistrimi.slice(0, 10)])
    detajeList.push(["Statusi", bill.Statusi.Emri])
    detajeList.push(["Lloji", bill.Lloji.Emri])
    detajeList.push(["Procedura", bill.Procedura.Emri])
    detajeList.push(["Propozues", bill.BillPropozues.map(procedure => procedure.Propozues.Emri).toString()])
    console.log(detajeList)
    return (
        <ListGroup>
            {detajeList.map(detaj => <ListGroupItem><b>{detaj[0]}</b> : {detaj[1]} </ListGroupItem>)}


        </ListGroup>
    );
};



export default Detaje;
